<template>
  <div style="max-width:650px;margin:0px auto;padding-top:25px;">
<h3>Settings</h3>
<v-card class='mt-5 mb-10' elevation="2">
    <v-card-text><h3>Your Details</h3>
      <div><v-text-field label="Login" v-model="accountData.email" disabled></v-text-field></div>
      <div><v-text-field label="Name" v-model="accountData.yourName"></v-text-field></div>
   

    <div><v-text-field label="Phone" hide-details="true" v-model="accountData.mobile"></v-text-field></div>

    
<h3 class="mt-10">Business/Organisation Details</h3>
      <div><v-text-field label="Business Name" v-model="accountData.businessName"></v-text-field></div>
   
      <div><v-text-field label="Postcode" v-model="accountData.businessPostcode"></v-text-field></div>
</v-card-text>
<v-card-actions >
<v-btn @click="save" text :disabled="different">Save</v-btn>
</v-card-actions>

</v-card>
<h3>Secondary Account Users</h3>
<v-card class='mt-5 mb-10' elevation="2">

    <v-simple-table>
      
      <thead>
        <tr>
<th>Created</th>
<th>Join Activated</th>
<th>Email Address</th>
<th>Active</th></tr>
      </thead>
      <tbody>
<tr v-for="(item, index) in returnAdminUsers" :key="index">
<td>{{item.createdUTC}}</td>
<td>{{item.joinActivatedUTC}}</td>
<td>{{item.emailAddress}}</td>
<td>{{item.active}}</td>

</tr>
      </tbody>
    </v-simple-table>

<v-card-text>
<v-text-field v-model="userEmail"></v-text-field>
<v-btn @click="inviteUser" text>Invite User</v-btn>
</v-card-text>
</v-card>

<h3>Premium</h3>
<div>Allow SMS checkin to your own number. $10/month, + 30cents per checkin</div>



</div>
</template>

<script>

import {mapActions, mapGetters, mapMutations} from 'vuex';

import axios from 'axios';
export default {
  created:function(){
    this.location =  JSON.parse(JSON.stringify(this.returnAccount));
    this.accountData =  JSON.parse(JSON.stringify(this.returnAccount));
 
  

    this.loadAdminUsers(this.location.businessId);


  },
  computed:{
       ...mapGetters(["returnAccount","getAxiosConfig","returnAdminUsers"]),
       different(){
         return (JSON.stringify(this.accountData) == JSON.stringify(this.returnAccount)); 
       },
  },
  data: () => ({
    userEmail:"test@ndx.com.au",
    accountData:{}

  }),
  methods:{
      ...mapMutations(["setAccount"]),
      ...mapActions(["getToken","loadAdminUsers","createAdminUserInvite"]),
      inviteUser(){

        this.createAdminUserInvite({"EmailAddress":this.userEmail,"BusinessId": this.location.businessId});
      
      },
    save(){
         var t = this;

            t.getToken().then(function(idToken) {  
           
                  axios.post(
                  t.GLOBAL_CONFIG.apiURL + "Business/" + t.accountData.businessId,
                  {
                    "BusinessName":t.accountData.businessName,
                    "PostCode": t.accountData.businessPostcode,
                  },
                  t.getAxiosConfig
                  ).then(data=>{
                    
                    
                   t.setAccount(JSON.parse(JSON.stringify(t.accountData)));

                    alert("business details changed");}
                          
                  );


                });
    }
  },
  components: {
  
  }
}
</script>

<style>

</style>